import { useTranslations, useLocale } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { Link, usePathname } from '@/i18n/routing';
import { SearchLocationGroupsQuery, DESTINATIONS_PLACEMENT } from '@/query';
import { navigation } from './constants';

export const MobileMenu = ({ closeMenu }) => {
  const pathname = usePathname();
  const locale = useLocale();
  const t = useTranslations();
  const { data } = useSuspenseQuery(SearchLocationGroupsQuery, {
    variables: {
      filter: { purpose: DESTINATIONS_PLACEMENT },
      locale,
    },
    errorPolicy: 'ignore',
  });

  const mainPath = '/';
  const destinations = data?.listingGroups?.collection || [];

  const linkClassName =
    'flex w-full items-center rounded-10 text-slate-800 text-base font-medium max-sm:py-[6px] sm:py-4 !px-3 hover:bg-slate-100 hover:text-slate-800';

  return (
    <div className="flex flex-col justify-between h-full border-t border-slate-300">
      <div className="space-y-[10px] max-sm:px-4 p-6">
        {navigation.map((menuItem, i) =>
          !menuItem.links && !menuItem.destination ? (
            <Link
              onClick={closeMenu}
              key={menuItem.name}
              href={menuItem.href}
              className={linkClassName}
              data-testid={menuItem.dataTestId}
            >
              {t(menuItem.name)}
            </Link>
          ) : (
            <div key={i}>
              {menuItem.destination ? (
                <>
                  {pathname !== mainPath && (
                    <Link
                      onClick={closeMenu}
                      key={menuItem.name}
                      href={mainPath}
                      className={linkClassName}
                      data-testid={menuItem.dataTestId}
                    >
                      {t(menuItem.name)}
                    </Link>
                  )}
                  {destinations.map((group) => (
                    <Link
                      onClick={closeMenu}
                      key={group.slug}
                      href={`/destinations/${group.slug}`}
                      className={linkClassName}
                    >
                      {group.menuTitle || group.name}
                    </Link>
                  ))}
                </>
              ) : (
                <div className="px-3 mb-2.5">
                  <div className="border-t border-slate-300" />
                </div>
              )}
              <div className="flex flex-col gap-2.5">
                {menuItem.links.map((item) => (
                  <Link
                    onClick={closeMenu}
                    key={item.name}
                    href={item.href}
                    className={linkClassName}
                    data-testid={item.dataTestId}
                  >
                    {t(item.name)}
                  </Link>
                ))}
              </div>
              {menuItem.destination ? (
                <div className="px-3 my-2.5">
                  <div className="border-t border-slate-300" />
                </div>
              ) : null}
            </div>
          )
        )}
      </div>
      <div className="px-6 max-sm:pt-3 sm:pt-4 pb-8 border-t border-slate-300 max-sm:space-x-6 flex">
        <Link
          href="https://core.guestit.se"
          target="_blank"
          className="btn max-sm:btn-second sm:btn-primary sm:w-full max-sm:flex-1"
        >
          {t('menu.fourth')}
        </Link>
      </div>
    </div>
  );
};
